import { render, staticRenderFns } from "./CalendarMonth.vue?vue&type=template&id=923e0d16&"
import script from "./CalendarMonth.vue?vue&type=script&lang=js&"
export * from "./CalendarMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports